import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';
// template components
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
// theme
import Nm2024Theme from '../../nm2024Theme/colors';

// eslint-disable-next-line import/prefer-default-export
export const SectionContainerNm2024 = styled(SectionContainer)`
  ${({ theme, themeType, backgroundVariant, withBottomBorder }) => {
    let thisBgColor = theme.colors.neutral.white;

    if(themeType === 'darkTheme'){
      thisBgColor = Nm2024Theme.navy.navy;
    }

    if(backgroundVariant === 'lightB'){
      thisBgColor = Nm2024Theme.yellow.yellow80;
    }else if(backgroundVariant === 'lightC'){
      thisBgColor = Nm2024Theme.sky.sky80;
    }

    return css`
      && {
        background-color: ${thisBgColor};
        ${withBottomBorder && `border-bottom: ${rem(2)} solid ${Nm2024Theme.yellow.yellow};`};
      }
    `;
  }
}`;
